import {PAGE_URL, PERMISSION_KEY} from "../services/constant";
const nebulaUltraMetadataMenuRegistry = {
    personalize_nebulaUltraMetadata: {
        label: "Nebula Ultra Metadata",
        link: PAGE_URL.NEBULA_ULTRA_METADATA_PAGE,
        key: PAGE_URL.NEBULA_ULTRA_METADATA_PAGE,
        resourceKey: PERMISSION_KEY
    }
}

export default nebulaUltraMetadataMenuRegistry;
